exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Base_root_1cawF {\n  margin: 0;\n  font-size: 18px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\nhtml {\n  height: 100%;\n  touch-action: manipulation; /* https://developers.google.com/web/updates/2013/12/300ms-tap-delay-gone-away */\n}\n\nbody {\n  margin: 0;\n  height: 100%;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nform {\n}\n\nlabel {\n  display: block;\n}\n\ninput, select, textarea {\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n  border: 0px solid #aaa;\n  border-radius: 0;\n  border-bottom: 1px solid #CFCFCF;\n}\n\nbutton, input, optgroup, select, textarea {\n  font: inherit;\n  margin: 0;\n}\n\nh1, h2 {\n  font-weight: 300;\n}\n\noption {\n  font-weight: 300;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Base_root_1cawF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/common/components/Base/Base.css
// module id = 229
// module chunks = 0 1 2 3